import logo from "assets/images/integrations/mailchimp_logo.jpg";
import { useCallback, useMemo } from "react";
import { connect, ConnectedProps } from "react-redux";
import { RootReduxState } from "../../../../../utils/types";
import { AvailableIntegrationCardAddButton } from "../../components/AvailableIntegrationCardAddButton";
import { AvailableIntegrationCardExplanationWrapper } from "../../components/AvailableIntegrationCardExplanationWrapper";
import { AvailableIntegrationCardHeader } from "../../components/AvailableIntegrationCardHeader";
import { AvailableIntegrationCardWrapper } from "../../components/AvailableIntegrationCardWrapper";
import { OAuthSetup } from "../../components/OAuthSetup/OAuthSetup";
import { ConnectViewComponentProps, IntegrationType } from "../../types";
import { MailchimpIntegrationSettings } from "./types";

type MailchimpConnectViewComponentOwnProps = ConnectViewComponentProps;

const mapStateToProps = (state: RootReduxState) => {
  const selectedShop = state.getIn([
    "customerBackendDashboard",
    "userData",
    "selectedShop"
  ]) as string;

  return {
    integrationList: state
      .getIn([
        "customerBackendDashboard",
        "shops",
        selectedShop,
        "integrations",
        "data",
        IntegrationType.MAILCHIMP
      ])
      ?.toJS() as MailchimpIntegrationSettings[] | undefined
  };
};

const connector = connect(mapStateToProps);

type MailchimpConnectViewComponentProps = MailchimpConnectViewComponentOwnProps &
  ConnectedProps<typeof connector>;

const MailchimpConnectViewComponent = (props: MailchimpConnectViewComponentProps) => {
  const { connectingType, onStartConnecting, onStopConnecting, integrationList } = props;

  const isConnected = useMemo(
    () =>
      integrationList?.some((integration) => {
        return integration.oath2Config && integration.oath2Config.accessToken;
      }) || false,
    [integrationList]
  );

  return (
    <AvailableIntegrationCardWrapper>
      {connectingType === IntegrationType.MAILCHIMP && (
        <OAuthSetup integrationType={IntegrationType.MAILCHIMP} onFinish={onStopConnecting} />
      )}
      <AvailableIntegrationCardHeader image={logo} text="MailChimp" />
      <AvailableIntegrationCardExplanationWrapper>
        Connect your MailChimp account to sync your customers and send email campaigns.
      </AvailableIntegrationCardExplanationWrapper>
      <AvailableIntegrationCardAddButton
        isConnected={isConnected}
        loading={connectingType !== undefined}
        onConnect={useCallback(
          () => onStartConnecting(IntegrationType.MAILCHIMP),
          [onStartConnecting]
        )}
      />
    </AvailableIntegrationCardWrapper>
  );
};

export const MailchimpConnectView = connector(MailchimpConnectViewComponent);
